<div class="header">
  <span class="title">Custom Pre-approval Editor</span>
  <div>
    <span class="tip wmaccess-pdf-editor-Highlighter"></span>
    <div  style="display: flex;">
      <div class="column column-fico" style="width: 150px;">
        
        <label  class="arb-input">
          <span class="title">Font Style</span>
          <!-- <input  type="number" class="input"  [value]="fontStyle" (input)="handlefontStyleChange($event.target.value)"> -->
            <input type="text"
                   placeholder="Select Font style"
                   aria-label="Number"
                   matInput
                   [formControl]="myControl"
                   [matAutocomplete]="auto" 
                   style="width:140px; margin-right:10px;"
                   [value]="fontStyle"
            >
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
              <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                {{option}}
              </mat-option>
            </mat-autocomplete>
        </label>
      </div>

      <div class="column column-fico" >
        <label  class="arb-input">
          <span class="title">Font Size</span>
          <input  type="number" class="input"  [value]="fontSize" (input)="handlefontSizeChange($event.target.value)">
        </label>
      </div>
      <div class="column column-fico">
        <label  class="arb-input">
          <span class="title">Spacing</span>
          <input  type="number" class="input"  [value]="spacing" (input)="handleSpacingChange($event.target.value)">
        </label>
      </div>
      <div class="colors-container">
        <label class="arb-input">
          <span class="title">Font Color</span>
          <input type="color" id="favcolor" name="favcolor" value="#ff0000" style="background: white; padding: 1rem;"(change)="changeFontColor($event)"><br><br>
        </label>
        </div>
    </div>

    <div class="icons">
      <ng-template #notCustomPreapproval style="order:-1 !important">
        <mat-icon (click)="enableCustomePreapproval()" style="padding: 6px; border: 0.5px solid #80808059; border-radius:3px;" svgIcon="edit_white"></mat-icon>
      </ng-template>

      <mat-icon (click)="crop()" *ngIf="cropperEnabled$ | async" class="tick-crop" svgIcon="tick_green"></mat-icon>
      <mat-icon (click)="undo()" class="undo-icon" svgIcon="undo"></mat-icon>

      <mat-icon class="enabled-cropper" (click)="disableEditor()" *ngIf="cropperEnabled$ | async; else cropperDisabled" svgIcon="enable_crop"></mat-icon>
      <ng-template #cropperDisabled>
        <mat-icon (click)="enableCropper()" svgIcon="disable_crop"></mat-icon>
      </ng-template>

      <mat-icon (click)="disableEditor()" *ngIf="rectangleRendererEnabled$ | async; else notEditable" svgIcon="create_white"></mat-icon>
      <mat-icon (click)="disableEditor()" *ngIf="rectangleRendererHighlighterEnabled$ | async; else notEditableHighlighter" class="highlighterIcon" style="background-color: #ffff00;" svgIcon="highlighter"></mat-icon>
      <mat-icon (click)="disableEditor();disableCustomPreApprovalBtn()" *ngIf="customPreapproval$ | async; else notCustomPreapproval" style="background-color: black; fill: white; padding: 6px; border: 0.5px solid #80808059; border-radius:5px; "  svgIcon="edit_white"></mat-icon>
      
      <ng-template #notEditable>
        <mat-icon (click)="enableRectangleRenderer()" svgIcon="create_black"></mat-icon>
      </ng-template>
      
      <ng-template #notEditableHighlighter>
        <mat-icon (click)="enableRectangleRendererHighlighter()" class="highlighterIcon"  svgIcon="highlighter"></mat-icon>
      </ng-template>

    </div>
   
  </div>
</div>
<div  class="arb-input" style="display: flex; flex-direction: row;">
  <span  *ngFor="let field of custFields | keyvalue ;let i=index"  [id]="'field'+i" draggable="true" (dragstart)="drag($event)" style="margin: 0 5px 0 5px;    height: fit-content;margin: 0px 5px; padding: 0.5rem;border: 1px solid;border-radius: 9px">{{field.key | titlecase}}</span>
  </div>
<div
*ngIf="customPreApprovalBtnFlag"
class="error"
style="text-align: center;margin-bottom: 5px;font-size: 14px; line-height: 20px;">
Please Add Custom Values from Above Icons
</div>



<arb-pdf-editor
  *ngIf="isPdf"
  [file]="file"
  [customParams$]="customParams$"
  [rendererType$]="rendererType$"
  [undo$]="undo$"
  [crop$]="crop$"
  (filesChange)="onFilesChange($event)"
  (pageChanged)="onPageChanged()"
  (typeFlagEvent)="getTypeFlagEvent($event)"
  (changesCordinateList)=onCordinatesChange($event)
  >
  
</arb-pdf-editor>

<arb-image-editor
  *ngIf="!isPdf"
  [customParams$]="customParams$"
  [rendererType$]="rendererType$"
  (changesCordinateList)=onCordinatesChange($event);
  [file]="file"
  [undo$]="undo$"
  [crop$]="crop$"
  (filesChange)="onFilesChange($event)"
  (typeFlagEvent)="getTypeFlagEvent($event)">
</arb-image-editor>

<div class="footer">
  <mat-checkbox [formControl]="agreementControl" color="primary">
    <!-- <span class="agreement-text">I certified that this document has all private information redacted.</span> -->
    <span class="agreement-text">Please ensure this document has all private information redacted.</span>
  </mat-checkbox>
  <div class="buttons">
    <button mat-dialog-close mat-flat-button (click)="cancel()" >Cancel</button>
    <button
      [disabled]="!((allowSave$ | async) && !!files.length) || customPreApprovalBtnFlag"
      (click)="save()"
      mat-flat-button
      color="primary">
      Save
    </button>
  </div>
</div>
